// components/AuditCommissionGroup.jsx
import React from "react";
import { Box } from "@mui/material";
import { EmployeeCard } from "components/EmployeeCard";
import { useTranslation } from "react-i18next";

const AuditCommissionGroup = ({ employees, getTranslatedField, classes }) => {
  const auditEmployees = employees.filter(
    (emp) => emp.role?.position_en === "The Audit Commission"
  );


  const { i18n } = useTranslation();

  if (auditEmployees.length === 0) return null;

  // Маппинг английского ключа роли → локализованное название
  const getLocalizedRoleTitle = (roleEn, lang) => {
    const roleMap = {
      Governance: {
        ru: "Правление",
        ky: "Башкармалык",
        en: "Governance",
      },
      "The Audit Commission": {
        ru: "Ревизионная комиссия",
        ky: "Ревизиялык комиссия",
        en: "The Audit Commission",
      },
      Management: {
        ru: "Дирекция",
        ky: "Дирекция",
        en: "Management",
      },
    };

    return roleMap[roleEn]?.[lang] || roleMap[roleEn]?.en || roleEn;
  };

  // Разбиваем массив на части
  const firstRow = auditEmployees.slice(0, 2); // первые 2
  const remaining = auditEmployees.slice(2); // остальные

  return (
    <Box sx={{ marginBottom: 5 }}>
      {/* Заголовок */}
      <Box className={classes.title} sx={{ textAlign: "center" }}>
        {getLocalizedRoleTitle("The Audit Commission", i18n.language)}
      </Box>

      {/* Первый ряд: 2 карты */}
      {firstRow.length > 0 && (
        <Box className={classes.teamList}>
          {firstRow.map((employee) => (
            <EmployeeCard
              key={employee.id}
              employee={{
                id: employee.id,
                name: getTranslatedField(employee, "name"),
                position: getTranslatedField(employee, "position"),
                image: employee.image?.trim(),
                contact_ru: employee.contact_ru,
                contact_en: employee.contact_en,
                contact_ky: employee.contact_ky,
                simple_position_ru: employee.simple_position_ru,
                simple_position_en: employee.simple_position_en,
                simple_position_ky: employee.simple_position_ky,
              }}
            />
          ))}
        </Box>
      )}

      

      {/* Остальные: по 4 в ряд */}
      {remaining.length > 0 && (
        <Box className={classes.teamListRev}>
          {remaining.map((employee) => (
            <EmployeeCard
              key={employee.id}
              employee={{
                id: employee.id,
                name: getTranslatedField(employee, "name"),
                position: getTranslatedField(employee, "position"),
                image: employee.image?.trim(),
                contact_ru: employee.contact_ru,
                contact_en: employee.contact_en,
                contact_ky: employee.contact_ky,
                simple_position_ru: employee.simple_position_ru,
                simple_position_en: employee.simple_position_en,
                simple_position_ky: employee.simple_position_ky,
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default AuditCommissionGroup;
